import { AiOutlineCalendar } from "react-icons/ai";
import { MdCode, MdOutlineEmail, MdOutlineSync } from "react-icons/md";

//Page / Card Title: MS Outlook
export const outlookData = [
  {
    title: "Embed Outlook Calendar in WordPress",
    video: true,
    videoId: "Ngp5Av4i1ZU",
    videoType: "youtube",
    icon: <AiOutlineCalendar className='text-white fs-5' />
  },
  {
    title: "Shortcode Builder",
    video: false,
    videoId: "",
    videoType: "",
    icon: <MdCode className='text-white fs-5' />
  },{
    title: "Send emails without SMTP",
    video: false,
    videoId: "",
    videoType: "",
    icon: <MdOutlineEmail className='text-white fs-5' />
  },{
    title: "Schedule Meetings using Outlook Calendar",
    video: false,
    videoId: "",
    videoType: "",
    icon: <AiOutlineCalendar className='text-white fs-5' />
  },{
    title: "Bi-Directional Contact Sync",
    video: false,
    videoId: "",
    videoType: "",
    icon: <MdOutlineSync className='text-white fs-5' />
  }
]